import React from "react";
import { useHistory } from "react-router-dom";
import Header from "../components/@header/header";
import styles from "../assets/containers/blockPage.module.css";
import cookie from "react-cookies";
import { iesLogout } from "../service/service";
import { t } from "../lib/i18n";

const ErrorPage = props => {
    const history = useHistory();

    const handleTryAgain = async () => {
        const id_token_hint = localStorage.getItem("token_info_hint").replace(/^"|"$/g, "");

        await iesLogout({id_token_hint})

        history.push("/#/");
        window.location.reload();
    };

    return (
    <>
        <div>
            <Header className={styles["hide-options-header"]} menuLanguage={true}/>
        </div>
        <div className={styles["container-content"]}>
            <h2 className={styles["container-title"]}>{t("An authentication error occurred.")}</h2>
            <button
                className={`${styles.button} ${styles.button_logout}`}
                onClick={handleTryAgain}
            >
                <span>{t("Try Again")}</span>
            </button>
        </div>
    </>
  );
};

export default ErrorPage;
 